import AttorneySection from "../attorney/AttorneySection";
import ReductionsSection from "../reductions/ReductionsSection";
import SettlementAmountSection from "../settlement-amount/SettlementAmountSection";

export default function LeftUppperContainer({ variant, className = "" }) {
  if (variant === "attorney") {
    return <AttorneySection className={className} />;
  }

  return (
    <div className={`flex min-h-[420px] flex-col gap-6 ${className}`}>
      <SettlementAmountSection />
      <ReductionsSection />
    </div>
  );
}
